import { render, staticRenderFns } from "./rulerSet.vue?vue&type=template&id=8934bd8c&scoped=true&"
import script from "./rulerSet.vue?vue&type=script&lang=js&"
export * from "./rulerSet.vue?vue&type=script&lang=js&"
import style0 from "./rulerSet.vue?vue&type=style&index=0&id=8934bd8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8934bd8c",
  null
  
)

export default component.exports